export const ADD_SIDEBAR_DETAILS = "ADD_SIDEBAR_DETAILS";